import React from 'react';
import { MessageCircle } from 'lucide-react';

const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/916377733291?text=Hi%20Shiv%20Shakti%20Hospitality"
      target="_blank"
      rel="noopener noreferrer"
      className="group bg-[#25D366] hover:bg-[#128C7E] text-white w-16 h-16 rounded-full shadow-xl hover:shadow-2xl transition-all duration-300 flex items-center justify-center hover:scale-110 hover:-translate-y-1 active:scale-95 z-[99] border-4 border-white/50 hover:border-white/80"
      aria-label="WhatsApp"
    >
      <MessageCircle size={24} className="group-hover:scale-110 transition-transform duration-200" />
    </a>
  );
};

export default WhatsAppButton;

